import { render, staticRenderFns } from "./adminDialog.vue?vue&type=template&id=27bf244b&"
import script from "./adminDialog.vue?vue&type=script&lang=js&"
export * from "./adminDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports